const getBaseUrl = () => {
  const host = window.location.hostname;

  if (host === '41.207.44.226') {
    return 'http://41.207.44.226:3001';
  } else if (host === '192.168.88.224') {
    return 'http://192.168.88.224:3001';
  } else if (host === 'localhost') {
    return 'http://localhost:3001';
  } else {
    // Par défaut, utilisez une URL publique ou définissez un comportement
    return 'https://dcca.mg';
  }
};

export default getBaseUrl;
